import "pixi-filters";

import Components from "slotworks/components/components";
import { AssetConfigSchema } from "slotworks/config/asset-config-schema";
import { ComponentConfigSchema } from "slotworks/config/component-config-schema";
import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { I18NConfigSchema } from "slotworks/config/i18n-config-schema";
import { SoundConfigSchema } from "slotworks/config/sound-config-schema";
import GameLoop from "slotworks/core/game-loop";
import CanvasManager from "slotworks/graphics/canvas/canvas-manager";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import ParticleManager from "slotworks/graphics/particles/particle-manager";
import SpineManager from "slotworks/graphics/spine/spine-manager";
import Loader from "slotworks/loader/loader";
import GameState from "slotworks/model/game-state";
import AuthRequestPayload from "slotworks/model/gameplay/requests/auth-request-payload";
import SettingsModel from "slotworks/model/settings/settings-model";
import CommsManager from "slotworks/server/comms-manager";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import { StateMachineConfig } from "slotworks/state-machine/parser/config/state-machine-config-schema";
import StateParser from "slotworks/state-machine/parser/state-parser";
import StateMachine from "slotworks/state-machine/state-machine";
import Sequence from "slotworks/utils/contracts/sequence";
import DeviceInfo from "slotworks/utils/device-info";

declare const __DEBUG__: boolean;
export default class AppWorks {

    public static go(
        gameConfig: GameConfigSchema,
        stateConfig: StateMachineConfig,
        assetConfig: AssetConfigSchema,
        componentConfig: ComponentConfigSchema,
        soundConfig: SoundConfigSchema,
        i18nConfig: I18NConfigSchema,
        ready: Function,
        autoStartStateMachine: boolean = true
    ) {

        window.onerror = (e) => {
            let message = Services.translations.get("General Error");

/////////////////////////////
////////////////////////////
///////////////////////////////////////
/////////////
//////////////////////

            Components.alert.error(message, true).execute();
            window.onerror = null;
        };

        DeviceInfo.selectLayout(gameConfig.layouts);

        Services.sound.init(soundConfig);

        StateMachine.onStateEnter.add((state: string) => Services.sound.event(SoundEvent.enter_state_STATE, state));
        StateMachine.onStateExit.add((state: string) => Services.sound.event(SoundEvent.exit_state_STATE, state));

        Layers.onEnterScene.add((layer: string, scene: string) => Services.sound.event(SoundEvent.enter_scene_LAYER_SCENE, layer, scene));
        Layers.onExitScene.add((layer: string, scene: string) => Services.sound.event(SoundEvent.exit_scene_LAYER_SCENE, layer, scene));

        CanvasManager.init(assetConfig);
        GraphicsManager.init(assetConfig);
        ParticleManager.init(assetConfig);

        Components.config = componentConfig;
        Components.preinit();

        SmartUIManager.init();

        GameLoop.init().then(() => {

            Loader.loadI18n(SettingsModel.language || "en").then((json) => {

                Services.translations.setLanguage(SettingsModel.language || "en");
                Services.translations.setConfig(i18nConfig);
                Services.translations.load(json);
                Services.translations.updateDOMTexts();

                GameState.newGame();

                new Sequence([
                    () => Loader.setup(assetConfig),
                    () => CommsManager.request(new AuthRequestPayload()),
                    () => Loader.load()
                ]).then(() => {

                    SpineManager.init(assetConfig);

                    CanvasManager.gameLoaded();

                    const defaultState = StateParser.parse(stateConfig, StateMachine);

                    ready();

                    if (autoStartStateMachine) {
                        StateMachine.setCurrentState(defaultState);
                    }
                });
            });
        });
    }

    private constructor() { }
}
